angular.module('shared').factory('IntercomService', ["$rootScope", function($rootScope) {
  return {
    track: _.debounce(function(event) {
      if (window.Intercom) {
        return window.Intercom('trackEvent', event);
      }
    }, 100)
  };
}]);
